"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _util = require("../util");

var _campaignSection = require("./campaignSection");

var _campaignSection2 = _interopRequireDefault(_campaignSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Campaigns = function Campaigns(data) {
  var _this = this;

  (0, _classCallCheck3.default)(this, Campaigns);

  this.data = data;
  this.campaignSections = [];
  this.data._owned = false;
  if (this.data.sections.length === 1) {
    var sections = this.data.sections[0];
    this.data._owned = sections.satisfied && sections.owned;
  }
  this.data.sections.forEach(function (s) {
    s._allFromStore = data._allFromStore;
    s.cid = data.code;
    var section = (0, _util.create)(_campaignSection2.default, s);
    _this.campaignSections.push(section);
  });
}

// setInWarehousePack(s) {
//   this.data._allFromStore = s
//   this.campaignProducts.forEach(p => {
//     p.setInWarehousePack(s)
//   })
// }

;
// import campaignProduct from "./campaignProduct";


exports.default = Campaigns;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/ipos/campaign.js
// module id = 864
// module chunks = 0